import {
  ReservationFlowSelectedPaymentMethodPrepaymentWithStripe,
  ReservationFlowSelectedPaymentMethodPrepaymentWithMulpay,
  ReservationFlowSelectedPaymentMethodCreditCardHoldingNewCreditCardInfo,
  ReservationFlowSelectedPaymentMethodOnfilePrepaymentWithMulpay,
  ReservationFlowSelectedPaymentMethodNewCreditCard,
} from '../interfaces/reservation_flow';
import { MulpayCardData } from 'src/interfaces/mullpayCardData';
export const GMO_PG_PAYMENT_POPUP_WINDOW_NAME = 'gmo-pg-payment-popup-window';

type PaymentMethodContext = {
  stripeConfirmationTokenId?: string;
  isMulpayOrderEnabled?: boolean;
  mulpayCardData?: MulpayCardData;
  // isStoreCreditCardのデフォ値を決定するために使う値
  // 月謝は保存するか選択できない経路があるため、デフォでは保存する
  productType: 'subscription' | 'ticket_book';
};

export const convertPaymentMethodForSubmission = (
  paymentMethod:
    | ReservationFlowSelectedPaymentMethodCreditCardHoldingNewCreditCardInfo
    | ReservationFlowSelectedPaymentMethodNewCreditCard,
  context: PaymentMethodContext,
):
  | ReservationFlowSelectedPaymentMethodPrepaymentWithStripe
  | ReservationFlowSelectedPaymentMethodPrepaymentWithMulpay
  | ReservationFlowSelectedPaymentMethodOnfilePrepaymentWithMulpay => {
  switch (paymentMethod.type) {
    case 'credit_card':
      if (context.isMulpayOrderEnabled) {
        if (context.mulpayCardData?.type === 'existing') {
          return {
            type: 'onfile_prepayment_with_gmo_credit' as const,
            onfile_card_identifier:
              context.mulpayCardData.mulpayOnfileCardIdentifier,
          };
        } else {
          throw new Error('mulpayCardData is invalid');
        }
      } else {
        return {
          type: 'prepayment_with_stripe',
          confirmation_token: null,
          use_last_used: true,
          save_as_last_used: false,
        };
      }
    case 'new_credit_card':
      if (
        context.isMulpayOrderEnabled &&
        context.mulpayCardData?.type === 'new' &&
        context.mulpayCardData.mulpayMpToken !== undefined
      ) {
        return {
          type: 'prepayment_with_gmo_credit',
          mp_token: context.mulpayCardData.mulpayMpToken,
          save_as_last_used:
            context.productType === 'subscription'
              ? true
              : paymentMethod.isStoreCreditCard || false,
        };
      }

      // stripe決済であればconfirmation_tokenは必ずある想定だが、型定義上はundefinedが入りうるのでチェック
      if (typeof context.stripeConfirmationTokenId === 'undefined') {
        throw new Error('stripeConfirmationTokenId is required');
      }

      return {
        type: 'prepayment_with_stripe',
        confirmation_token: context.stripeConfirmationTokenId,
        use_last_used: false,
        save_as_last_used:
          context.productType === 'subscription'
            ? true
            : paymentMethod.isStoreCreditCard || false,
      };
    default:
      return paymentMethod;
  }
};

export const isStripeSpecificError = (
  error: unknown,
): error is stripe.StripeError => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'code' in (error as stripe.StripeError) &&
    'type' in (error as stripe.StripeError) &&
    'message' in (error as stripe.StripeError)
  );
};

export const openGmoPgPaymentPopupWindow = (url: string) => {
  // ポップアップウィンドウのサイズと位置
  // ブラウザが全画面、または mobile の場合はpopupは別タブで開かれるので以下の設定は参照しない
  const w = 800;
  const h = 600;
  // 親ウィンドウの座標とサイズ
  const parentX = window.screenX ?? window.screenLeft ?? 0;
  const parentY = window.screenY ?? window.screenTop ?? 0;
  const parentW = window.outerWidth ?? window.innerWidth;
  const parentH = window.outerHeight ?? window.innerHeight;

  // 親ウィンドウの中央に配置
  const left = Math.round(parentX + (parentW - w) / 2);
  const top = Math.round(parentY + (parentH - h) / 2);

  const params = `width=${w},height=${h},left=${left},top=${top},scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;
  const popup = window.open(url, GMO_PG_PAYMENT_POPUP_WINDOW_NAME, params);

  return popup;
};
